// Initialisation de l'objet queryParams pour stocker les paramètres de requête
Shopify.queryParams = {};

/*********************************************************************************************
 * Refresh the collection page with the provided filters.
 *
 * @param {string} url_filters - The URL parameters pour les filtres.
 */
async function refreshCollectionPageWithFilters(url_filters) {
    const currentUrl = `${location.protocol}//${location.host}${location.pathname}`;
    const fetchUrl = `${currentUrl}?${url_filters}&section_id=${returnShopifySectionIdShort()}`;

    // Ajout de la classe 'mm-loading' avant le fetch
    document.querySelector('.mm-grid-card-collection').classList.add('mm-is-loading');

    try {
        const response = await fetch(fetchUrl);
        if (!response.ok) {
            console.error(`Erreur lors du fetch : statut ${response.status}`);
            return;
        }
        const newPageString = await response.text();

        // Créer un élément temporaire pour parser le HTML renvoyé
        const newPageEl = document.createElement('DIV');
        newPageEl.innerHTML = newPageString;

        // 1. Mise à jour des articles de la collection
        const newSection = newPageEl.querySelector('.mm-grid-card-collection');
        const currentSection = document.querySelector('.mm-grid-card-collection');
        if (newSection && currentSection) {
            currentSection.innerHTML = newSection.innerHTML;
        }

        // 2. Mise à jour des filtres actifs (.active-filters) en copiant index par index
        const activeFiltersNew = newPageEl.querySelectorAll('.active-filters');
        const activeFiltersCurrent = document.querySelectorAll('.active-filters');
        activeFiltersNew.forEach((newFilterEl, i) => {
            if (activeFiltersCurrent[i]) {
                activeFiltersCurrent[i].innerHTML = newFilterEl.innerHTML;
            }
        });

        // 3. Mise à jour des autres éléments '.mm-reload'
        const reloadElemsNew = newPageEl.querySelectorAll('.mm-reload');
        const reloadElemsCurrent = document.querySelectorAll('.mm-reload');
        reloadElemsNew.forEach((newReloadEl, i) => {
            if (reloadElemsCurrent[i]) {
                reloadElemsCurrent[i].innerHTML = newReloadEl.innerHTML;
            }
        });

        // 4. Mise à jour de l'URL dans l'historique sans recharger la page
        window.history.replaceState(null, document.title, `${currentUrl}?${url_filters}`);

        // 5. Mise à jour du compteur de filtres actifs après le rafraîchissement
        updateFilterCount();

        document.dispatchEvent(new CustomEvent('reloadLazyLoad'));

    } catch (err) {
        console.error('Erreur réseau lors du refreshCollectionPageWithFilters :', err);
    } finally {
        // On retire la classe 'mm-loading' quoi qu'il arrive
        const gridEl = document.querySelector('.mm-grid-card-collection');
        if (gridEl) {
            gridEl.classList.remove('mm-is-loading');
        }
    }
}

/*********************************************************************************************
 * Update the sort_by query parameter et recharger la page avec le nouveau tri.
 *
 * @param {HTMLSelectElement} select - Le select pour le tri.
 */
function mmSortByChanged(select) {
    const hiddenSelect = document.getElementById('mmSortByHiddenElem');
    if (hiddenSelect) {
        hiddenSelect.value = select.value;
        fakeSubmitForm();
    }
}

/*********************************************************************************************
 * Met à jour le compteur de filtres actifs.
 */
function updateFilterCount() {
    const checkedFilters = document.querySelectorAll('.hidden-checkbox:checked');
    const count = checkedFilters.length;
    const counterEl = document.getElementById("checked-count");
    if (counterEl) {
        counterEl.textContent = `(${count})`;
    }
}

/*********************************************************************************************
 * Serialize the form data et rafraîchir la collection.
 */
function fakeSubmitForm() {
    const form = document.querySelector(".collectionFacetsForm");
    if (!form) return;

    const url_filters = new URLSearchParams(new FormData(form)).toString();
    // On appelle la fonction asynchrone sans attendre le retour
    refreshCollectionPageWithFilters(url_filters);
}

/*********************************************************************************************
 * Délégation d'événement unique pour détecter les changements dans les inputs du formulaire.
 */
function checkForChanges() {
    const form = document.querySelector('.collectionFacetsForm');
    if (!form) return;

    // On écoute une seule fois sur le formulaire (délégation)
    form.addEventListener('change', (event) => {
        const target = event.target;
        if (target && target.tagName.toLowerCase() === 'input') {
            fakeSubmitForm();
        }
    });
}

/*********************************************************************************************
 * Fonctions pour la version mobile (largeur < 900px) : drawers filtres.
 */
if (window.innerWidth < 900) {
    function mmOpenFiltersMobile() {
        const wrapperMobile = document.querySelector('.mm-grid-second-container-filter');
        if (wrapperMobile) {
            wrapperMobile.classList.add('mm-open');
            document.documentElement.classList.add('stop-scrolling');
        }
    }

    function mmCloseFiltersMobile() {
        const wrapperMobile = document.querySelector('.mm-grid-second-container-filter');
        if (wrapperMobile) {
            wrapperMobile.classList.remove('mm-open');
            document.documentElement.classList.remove('stop-scrolling');
        }
    }

    function mmCheckDrawer() {
        if (document.location.href.indexOf('?open_filters') !== -1) {
            mmOpenFiltersMobile();
        }
    }

    // Si nécessaire, appeler mmCheckDrawer() après le chargement
    document.addEventListener("DOMContentLoaded", mmCheckDrawer);
}

/*********************************************************************************************
 * Toggle les accordeons pour les filtres.
 */
function mmFiltersAccordeons() {
    const filtersHeaders = document.querySelectorAll('.mm-cf-tag-filter-header');
    filtersHeaders.forEach((filtersHeader) => {
        filtersHeader.classList.add('active'); // Ouvre par défaut
        filtersHeader.addEventListener('click', () => {
            filtersHeader.classList.toggle('active');
        });
    });
}

/*********************************************************************************************
 * Sauvegarde de la préférence de la grille (petite vs grande).
 */
function saveGridPreference(isSmallGrid) {
    localStorage.setItem('mmGridPreference', isSmallGrid ? 'small' : 'large');
}

/*********************************************************************************************
 * Restaure la préférence de la grille depuis le localStorage.
 */
function restoreGridPreference() {
    const preference = localStorage.getItem('mmGridPreference');
    const grid = document.querySelector(".mm-grid-card-collection");
    const cards = document.querySelectorAll(".mm-product-card");
    if (!grid) return;

    if (preference === 'small') {
        grid.classList.remove("mm-grid-card-collection-lg");
        grid.classList.add("mm-grid-card-collection-sm");
        if (window.matchMedia("(min-width: 1024px)").matches) {
            cards.forEach(card => card.classList.add("mm-product-card-small"));
        }
        // Mettre à jour l'opacité des icônes
        const iconSm = document.querySelector('.mm-icon-grid-sm-svg');
        const iconLg = document.querySelector('.mm-icon-grid-lg-svg');
        if (iconSm) iconSm.style.opacity = '1';
        if (iconLg) iconLg.style.opacity = '0.5';
    } else {
        // Par défaut : grande grille
        grid.classList.remove("mm-grid-card-collection-sm");
        grid.classList.add("mm-grid-card-collection-lg");
        cards.forEach(card => card.classList.remove("mm-product-card-small"));
        // Mettre à jour l'opacité des icônes
        const iconSm = document.querySelector('.mm-icon-grid-sm-svg');
        const iconLg = document.querySelector('.mm-icon-grid-lg-svg');
        if (iconSm) iconSm.style.opacity = '0.5';
        if (iconLg) iconLg.style.opacity = '1';
    }
}

/*********************************************************************************************
 * Actions pour switcher en grande grille.
 */
function mmCollectionGridLg() {
    const grid = document.querySelector(".mm-grid-card-collection");
    const cards = document.querySelectorAll(".mm-product-card");
    if (!grid) return;

    grid.classList.remove("mm-grid-card-collection-sm");
    grid.classList.add("mm-grid-card-collection-lg");

    const iconSm = document.querySelector(".mm-icon-grid-sm-svg");
    const iconLg = document.querySelector(".mm-icon-grid-lg-svg");
    if (iconSm) iconSm.style.opacity = "0.5";
    if (iconLg) iconLg.style.opacity = "1";

    cards.forEach(card => card.classList.remove("mm-product-card-small"));

    saveGridPreference(false);
}

/*********************************************************************************************
 * Actions pour switcher en petite grille.
 */
function mmCollectionGridSm() {
    const grid = document.querySelector(".mm-grid-card-collection");
    const cards = document.querySelectorAll(".mm-product-card");
    if (!grid) return;

    grid.classList.remove("mm-grid-card-collection-lg");
    grid.classList.add("mm-grid-card-collection-sm");

    const iconSm = document.querySelector(".mm-icon-grid-sm-svg");
    const iconLg = document.querySelector(".mm-icon-grid-lg-svg");
    if (iconSm) iconSm.style.opacity = "1";
    if (iconLg) iconLg.style.opacity = "0.5";

    if (window.matchMedia("(min-width: 1024px)").matches) {
        cards.forEach(card => card.classList.add("mm-product-card-small"));
    }

    saveGridPreference(true);
}

/*********************************************************************************************
 * Initialisation de la préférence de grille au chargement.
 */
function initializeGridPreference() {
    const grid = document.querySelector(".mm-grid-card-collection");
    if (!grid) return;
    restoreGridPreference();
}

/*********************************************************************************************
 * Fonctions pour ouvrir/fermer le panneau de filtres sur desktop.
 */
function mmOpenFiltersPanel() {
    const panel = document.querySelector('.mm-filters-panel-wrapper');
    if (panel) {
        panel.classList.remove('mm-not-visible');
        document.body.classList.add('lenis-lock');
        if (window.lenis) window.lenis.stop();
    }
}

function mmCloseFiltersPanel() {
    const panel = document.querySelector('.mm-filters-panel-wrapper');
    if (panel) {
        panel.classList.add('mm-not-visible');
        document.body.classList.remove('lenis-lock');
        if (window.lenis) window.lenis.start();
    }
}

/*********************************************************************************************
 * Affichage dynamique du label couleur si une couleur est sélectionnée.
 */
document.addEventListener('DOMContentLoaded', () => {
    const colorInputs = document.querySelectorAll('input[type="checkbox"][data-label][data-category-handle]');
    colorInputs.forEach(input => {
        input.addEventListener('change', () => {
            const handle = input.dataset.categoryHandle;
            const sameCategory = document.querySelectorAll(`input[data-category-handle="${handle}"]`);
            const checkedLabels = Array.from(sameCategory)
                .filter(i => i.checked)
                .map(i => i.dataset.label);
            const displayDiv = document.querySelector(`#selected-color-name-${handle}`);
            if (displayDiv) {
                displayDiv.textContent = checkedLabels.length ? checkedLabels.join(', ') : '';
            }
        });
    });
});

/*********************************************************************************************
 * Synchronisation des cases à cocher du banner avec le formulaire principal.
 */
function mmSynchronizeFacets(input) {
    const value = input.value;
    const mainCheckbox = document.querySelector(`.collectionFacetsForm input[value='${value}']`);
    if (!mainCheckbox) return;

    // On inverse l'état sans déclencher le change plusieurs fois
    const wasChecked = mainCheckbox.checked;
    if (wasChecked !== input.checked) {
        mainCheckbox.checked = input.checked;
        // Déclencher explicitement un event "change"
        const changeEvent = new Event("change", { bubbles: true });
        mainCheckbox.dispatchEvent(changeEvent);
    }

    // Si une fonction externe doit s'exécuter
    if (typeof window.toggleRandomCards === 'function') {
        window.toggleRandomCards();
    }
}

/*********************************************************************************************
 * Effet "sticky" sur le scroll pour .mm-grid-first-container.
 */
window.addEventListener('scroll', () => {
    const el = document.querySelector('.mm-grid-first-container');
    if (!el) return;
    const rect = el.getBoundingClientRect();
    if (rect.top <= 150) {
        el.classList.add('sticky');
    } else {
        el.classList.remove('sticky');
    }
});

/*********************************************************************************************
 * Masquer la barre de filtre en footer lorsque le footer est visible.
 */
document.addEventListener("DOMContentLoaded", () => {
    const filterBanner = document.querySelector(".mm-wrapper-filter-banner");
    const footer = document.querySelector(".mm-footer");
    if (!filterBanner || !footer) return;

    window.addEventListener("scroll", () => {
        const footerTop = footer.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        if (footerTop <= windowHeight) {
            filterBanner.style.display = "none";
        } else {
            filterBanner.style.display = "";
        }
    });
});

/*********************************************************************************************
 * TABS pour les couleurs de verres.
 */
function mmVerresColorsTabs(button) {
    const container = button.closest('[data-container]');
    if (!container) return;

    const selected_category = button.dataset.category;
    // Activation du bouton cliqué
    container.querySelectorAll('.mm-wrapper-filter-title-category button').forEach(elem => {
        elem.classList.remove('active');
    });
    button.classList.add('active');

    // Affichage/masquage des items de couleurs
    const color_elements = container.querySelectorAll('[data-color]');
    color_elements.forEach(color_element => {
        if (color_element.dataset.categories.includes(selected_category)) {
            color_element.classList.remove('mm-none');
        } else {
            color_element.classList.add('mm-none');
        }
    });
}

// Initialisation du premier onglet pour les TABS couleurs verres
document.addEventListener("DOMContentLoaded", () => {
    const categoryButtons = document.querySelectorAll('.mm-filter-title-category');
    const listItems = document.querySelectorAll('.filter-group-display__list-item_color');

    if (categoryButtons.length > 0) {
        const firstButton = categoryButtons[0];
        firstButton.classList.add('active');
        const firstCategory = firstButton.getAttribute('data-category');
        listItems.forEach(item => {
            const categories = item.getAttribute('data-categories');
            if (categories && categories.includes(firstCategory)) {
                item.style.display = 'flex';
            } else {
                item.style.display = 'none';
            }
        });
    }
});

/*********************************************************************************************
 * TABS pour les couleurs montures.
 */
document.addEventListener("DOMContentLoaded", () => {
    const titlesMonture = document.querySelectorAll(".mm-filter-title-category-monture");

    if (titlesMonture.length > 0) {
        // Activation par défaut
        titlesMonture[0].classList.add("active");
        const targetIdMonture = titlesMonture[0].getAttribute("data-target-monture");
        const targetListMonture = document.getElementById(targetIdMonture);
        if (targetListMonture) {
            targetListMonture.classList.add("active");
        }
    }

    titlesMonture.forEach(titleMonture => {
        titleMonture.addEventListener("click", function () {
            const targetIdMonture = this.getAttribute("data-target-monture");
            const targetListMonture = document.getElementById(targetIdMonture);
            if (!targetListMonture) return;

            if (targetListMonture.classList.contains("active")) {
                targetListMonture.classList.remove("active");
                this.classList.remove("active");
            } else {
                document.querySelectorAll(".mm-wrapper-filters-list-monture").forEach(listMonture => {
                    listMonture.classList.remove("active");
                });
                document.querySelectorAll(".mm-filter-title-category-monture").forEach(title => {
                    title.classList.remove("active");
                });
                targetListMonture.classList.add("active");
                this.classList.add("active");
            }
        });
    });
});

/*********************************************************************************************
 * Checkbox range price : mise à jour du SVG et du texte selon coché/décoché.
 */
document.addEventListener('DOMContentLoaded', () => {
    const priceCheckboxes = document.querySelectorAll('.price-checkbox');
    priceCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', () => {
            const label = document.querySelector(`label[for="${checkbox.id}"]`);
            const svgPath = label?.querySelector('.price-checkbox-svg path');
            const textRange = label?.querySelector('.mm-text-range');
            if (checkbox.checked) {
                if (svgPath) svgPath.setAttribute('stroke', 'black');
                if (textRange) textRange.style.color = '#000';
            } else {
                if (svgPath) svgPath.setAttribute('stroke', 'white');
                if (textRange) textRange.style.color = '#6B6B6B';
            }
        });
        // Initial trigger pour définir l'état au chargement
        checkbox.dispatchEvent(new Event('change'));
    });
});

/*********************************************************************************************
 * Retourne l'ID de la section Shopify de la grille (avec préfixe 'shopify-section-').
 */
function returnShopifySectionId() {
    const gridElem = document.querySelector('.mm-grid-collection');
    if (!gridElem) return '';
    const gridSection = gridElem.closest('.shopify-section');
    return gridSection ? gridSection.id : '';
}

/*********************************************************************************************
 * Retourne l'ID de la section Shopify sans le préfixe 'shopify-section-'.
 */
function returnShopifySectionIdShort() {
    const fullId = returnShopifySectionId();
    return fullId.replace('shopify-section-', '');
}

/*********************************************************************************************
 * Initialisation générale après le chargement du DOM.
 */
document.addEventListener("DOMContentLoaded", () => {
    // Initialisation des filtres (délégation d'événements)
    checkForChanges();

    // Compter les filtres coché(es) au chargement
    updateFilterCount();

    // Accordeons filtres
    mmFiltersAccordeons();

    // Préférence de grille au chargement
    initializeGridPreference();
});


function mmChangeFilterPrice(button) {
  const minPrice = button.dataset.min;
  const maxPrice = button.dataset.max;
  const minInput = document.getElementById('mmFilterMinPriceInput');
  const maxInput = document.getElementById('mmFilterMaxPriceInput');

  minInput.value = minPrice;
  maxInput.value = maxPrice;
}
